import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			marginBottom: "40px",
			paddingLeft: "40px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		header: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "2",
			letterSpacing: "2px",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "26px",
			textTransform: "uppercase",
		},
		text: {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: "1.38",
			color: theme.palette.colors.oneMoreGrey,
			"& p": {
				margin: 0,
			},
			"& div": {
				marginBottom: "15px",
			},
			"& div:last-child": {
				marginBottom: 0,
			},
		},
		withoutPadding: {
			paddingLeft: "0 !important",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				paddingLeft: "35px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				paddingLeft: "25px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				paddingLeft: "8.33%",
				marginBottom: "20px",
			},
			header: {
				fontSize: "16px",
				marginBottom: "15px",
			},
			text: {
				fontSize: "14px",
			},
		},
	};
};

class TextBlock extends React.Component {
	static defaultProps = {
		text: null,
		header: null,
		insertDangerous: false,
		classes: {},
	};

	static propTypes = {
		text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	};

	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.withoutPadding]: !!this.props.withoutPadding,
				})}
			>
				{this.props.header && <div className={classes.header}>{this.props.header}</div>}
				{!this.props.insertDangerous && <div className={classes.text}>{this.props.text}</div>}
				{this.props.insertDangerous && (
					<div
						className={classes.text}
						dangerouslySetInnerHTML={{
							__html: this.props.text,
						}}
					/>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(TextBlock);
